import React, { createContext, useState, useEffect } from 'react';
import { collection, query, where, getDocs, getDoc, doc } from "firebase/firestore";
import { db } from '../firebase';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [data, setData] = useState({});
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const infoRef = doc(db, "info", "6qhznGOpD4N2RAXpQtdp");
            const educationRef = collection(db, "education");
            const experienceRef = collection(db, "experience");
            const skillRef = collection(db, "skills");

            // Get Info data
            let infoData = {};
            try {
                const infoSnapshot = await getDoc(infoRef);
                infoData = { id: infoSnapshot.id, ...infoSnapshot.data() };
                console.log(infoData);
            } catch (e) {
                infoData = {}
            }


            // Get Education Data
            let educationList = [];
            try {
                const educationSnapshot = await getDocs(educationRef);
                educationList = educationSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
            } catch (e) {
                educationList = [];
            }


            // Get Experience Data 
            let experienceList = [];
            try {
                const experienceSnapshot = await getDocs(experienceRef);
                experienceList = experienceSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
            } catch (e) {
                educationList = []
            }


            // Get Skills Data 
            let skillsList = [];
            try {
                const skillsSnapshot = await getDocs(skillRef);
                skillsList = skillsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
            } catch (e) {
                skillsList = []
            }

            const portfolioData = {
                'info': infoData,
                'education': educationList,
                'experience': experienceList,
                'skills': skillsList
            }

            setData(portfolioData);
            setLoading(false);

        };

        fetchData();
    }, []);

    useEffect(() => {
        // setLoading(false);
        console.log(data);
    }, [data]);

    return (
        <DataContext.Provider value={{ isLoading, data }}>
            {children}
        </DataContext.Provider>
    );
};